export const HIGH_LIMIT_MULTIPLIER = 5;

export const bidRequirements = (requirements, user, forcedStep) => [
  { key: 'nickname', done: !!user?.nickname },
  (requirements?.phone || forcedStep === 'phone') && { key: 'phone', done: !!user?.phoneVerifiedAt },
  (requirements?.discord || forcedStep === 'discord') && { key: 'discord', done: !!user?.discordId },
  (requirements?.card || forcedStep === 'card') && { key: 'card', done: !!user?.cardVerifiedAt },
].filter(Boolean).map(step => ({ ...step, done: step.done && forcedStep !== step.key }));

// A warning, never a cap. Buy-now takes precedence because its consequence
// is different from storing a private ceiling.
export const bidReview = ({ body, currentPrice, buyNowPrice, buyNowAvailable }) => {
  const instantPrice = Number(buyNowPrice);
  if (buyNowAvailable && instantPrice > 0 && (body.buyNow || body.amount >= instantPrice)) {
    return { kind: 'buyNow', amount: instantPrice, currentPrice: Number(currentPrice), body: { buyNow: true } };
  }
  if (!body.buyNow && Number(currentPrice) > 0 && body.amount >= Number(currentPrice) * HIGH_LIMIT_MULTIPLIER) {
    return { kind: 'highLimit', amount: body.amount, currentPrice: Number(currentPrice), body };
  }
  return null;
};
